import { apiClient } from '@/api/client';
import type { CreateMigrationInput, Migration, MigrationSourceInput, VerifySourceResult } from '@/features/migrations/types';

/** IMAP mailbox migrations — mail-admin-service `/mail-migrations`. */
export const migrationsApi = {
  list: async (mailboxId?: string): Promise<Migration[]> =>
    (await apiClient.get<Migration[]>('/mail-migrations', { params: mailboxId ? { mailboxId } : undefined })).data,
  get: async (id: string): Promise<Migration> => (await apiClient.get<Migration>(`/mail-migrations/${id}`)).data,
  create: async (body: CreateMigrationInput): Promise<Migration> =>
    (await apiClient.post<Migration>('/mail-migrations', body)).data,
  verifySource: async (body: MigrationSourceInput): Promise<VerifySourceResult> =>
    (await apiClient.post<VerifySourceResult>('/mail-migrations/verify-source', body, { timeout: 60_000 })).data,
  cancel: async (id: string): Promise<Migration> => (await apiClient.post<Migration>(`/mail-migrations/${id}/cancel`)).data,
  rerun: async (id: string, sourcePassword: string): Promise<Migration> =>
    (await apiClient.post<Migration>(`/mail-migrations/${id}/rerun`, { sourcePassword })).data,
};
